import { useTranslation } from 'react-i18next';
import { FOCUSRING } from '../focus';
import { useGekozenWerksoort, WERKSOORT_LABEL, WERKSOORTEN } from '../hooks/useGekozenWerksoort';
import { weeknummer } from '../week';
import { useVoorlees } from './Toestandsmelding';

/**
 * De Werksoortschakelaar (EXPERIENCE.md "Overal"): twee knoppen met `aria-pressed`, elk een eigen
 * tabstop, geen pijltoetsen. Wisselt de hele weergave tussen Vastleggen en Controles, nooit beide
 * tegelijk (M4). Een klik op de actieve knop doet niets; na een wissel blijft de focus op de knop en
 * zegt het Voorleesgebied "Controles, week 43".
 */
export function Werksoortschakelaar({ week }: { week: string }) {
  const { t } = useTranslation();
  const voorlees = useVoorlees();
  const { werksoort, kies } = useGekozenWerksoort();

  return (
    <div
      aria-label={t('qa.bediening.werksoort.label')}
      className="inline-flex w-fit items-center gap-1 rounded-[var(--radius-control)] bg-[var(--background-muted)] p-1 max-md:w-full"
      data-testid="werkkwaliteit-werksoortschakelaar"
      role="group"
    >
      {WERKSOORTEN.map((soort) => {
        const isActief = soort === werksoort;
        return (
          <button
            aria-pressed={isActief}
            className={`inline-flex flex-1 items-center justify-center whitespace-nowrap rounded-[var(--radius-control)] px-3 py-1 text-sm font-medium max-md:min-h-11 ${
              isActief ? 'bg-[var(--background)] text-[var(--foreground)] shadow-sm' : 'text-[var(--foreground-muted)] hover:text-[var(--foreground)]'
            } ${FOCUSRING}`}
            data-testid={`werkkwaliteit-werksoort-${soort}`}
            key={soort}
            onClick={() => {
              if (isActief) return;
              kies(soort);
              voorlees(t('qa.bediening.werksoort.gewisseld', { werksoort: t(WERKSOORT_LABEL[soort]), week: weeknummer(week) }));
            }}
            type="button"
          >
            {t(WERKSOORT_LABEL[soort])}
          </button>
        );
      })}
    </div>
  );
}
